export default {"src":"/_next/static/media/book-addon-brush-stroke.d22f4700.svg","height":87,"width":89,"blurWidth":0,"blurHeight":0};